/**
 * @generated SignedSource<<44ae0d45b7449a0e2c0fb3c8a11c8158>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type addProfanityRulePanel_AssignProductMutation$variables = {
  productIds?: ReadonlyArray<number> | null;
  profanityRuleId: string;
};
export type addProfanityRulePanel_AssignProductMutation$data = {
  readonly assignProductsToProfanityRule: {
    readonly result: boolean;
  } | null;
};
export type addProfanityRulePanel_AssignProductMutation = {
  response: addProfanityRulePanel_AssignProductMutation$data;
  variables: addProfanityRulePanel_AssignProductMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "productIds"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "profanityRuleId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "productIds",
        "variableName": "productIds"
      },
      {
        "kind": "Variable",
        "name": "profanityRuleId",
        "variableName": "profanityRuleId"
      }
    ],
    "concreteType": "ProductAssignmentResult",
    "kind": "LinkedField",
    "name": "assignProductsToProfanityRule",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "addProfanityRulePanel_AssignProductMutation",
    "selections": (v2/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "addProfanityRulePanel_AssignProductMutation",
    "selections": (v2/*:: as any*/)
  },
  "params": {
    "cacheID": "c02ed28244856953d072a37877f6c0a3",
    "id": null,
    "metadata": {},
    "name": "addProfanityRulePanel_AssignProductMutation",
    "operationKind": "mutation",
    "text": "mutation addProfanityRulePanel_AssignProductMutation(\n  $profanityRuleId: ID!\n  $productIds: [Long!]\n) {\n  assignProductsToProfanityRule(profanityRuleId: $profanityRuleId, productIds: $productIds) {\n    result\n  }\n}\n"
  }
};
})();

(node as any).hash = "42624be974d573fd45c8a98cc9384c5d";

export default node;
